import { FORMATIONS } from '@4cm/core/constants';

export const FIELD_LENGTH = 105; // goal-to-goal (z-axis in our world)
export const FIELD_WIDTH = 68;   // sideline-to-sideline (x-axis)
export const TOKEN_HEIGHT_Y = 0.6;

export interface PlayerSpot {
  role: string;
  x: number;
  y: number;
  z: number;
}

export const SUPPORTED_FORMATIONS = Object.keys(FORMATIONS).filter(
  (code) => FORMATIONS[code].positions.length === 11,
);

export const DEFAULT_FORMATION = '4-3-3';

export function projectFormation(code: string, side: 'home' | 'away' = 'home'): PlayerSpot[] {
  const preset = FORMATIONS[code] ?? FORMATIONS[DEFAULT_FORMATION];
  // Away mirrors across BOTH axes. z flip puts the away GK at -L/2 (their
  // own goal). x flip is the fix for the L/R inversion bug — without
  // it, an away "LB" landed on the coach's left edge, but from the away
  // team's own perspective (facing +z) their left side is the coach's
  // right. Flipping x keeps role-label semantics consistent for both
  // teams: LB == left-back from THAT team's POV, regardless of which
  // end they defend.
  const flip = side === 'away' ? -1 : 1;
  return preset.positions.map((pos) => ({
    role: pos.role,
    // norm.x ∈ [0,1] is left↔right (sideline) → world x ∈ [-FIELD_WIDTH/2, +FIELD_WIDTH/2]
    x: (pos.x - 0.5) * FIELD_WIDTH * flip,
    y: TOKEN_HEIGHT_Y,
    // norm.y ∈ [0,1] runs attacking (0) → defending (1) for the home side.
    // World z: home GK on +Z, attacking goal on -Z. Away mirrors via `flip`.
    z: (pos.y - 0.5) * FIELD_LENGTH * flip,
  }));
}
